var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('n-list',{attrs:{"value":"categories","text":"商品分類","fields":_vm.fields,"items":_vm.categories}})}
var staticRenderFns = []

export { render, staticRenderFns }